export default __webpack_public_path__ + "static/property-image-1-b2e6b1392554adde9c9f53a6f7746b92.jpg";